<script>
  function getClass (classname) {
    return document.getElementsByClassName(classname)
  }
  var poisArr = []
  export default {
    getClass,
    poisArr
  }
</script>



// WEBPACK FOOTER //
// methodCommon.vue?c9dc2b18